import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a7b7b266&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=a7b7b266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b7b266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7b7b266')) {
      api.createRecord('a7b7b266', component.options)
    } else {
      api.reload('a7b7b266', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a7b7b266&scoped=true&", function () {
      api.rerender('a7b7b266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSE5pGf3mGQX/JS/comp/SearchFilterTokens.vue"
export default component.exports